import { TFunction } from 'i18next';
import { z } from 'zod';

export const createUnderwriterConclusionSchema = (t: TFunction) => {
  return z
    .object({
      company_main_direction: z.string().min(1, t('Поле обязательное')),
      company_additional_direction: z.string().min(1, t('Поле обязательное')),
      self_pledge_product: z.string().min(1, t('Поле обязательное')),
      underwriter_conclusion: z.string().min(1, t('Поле обязательное')),
      financing_instrument: z.string().min(1, t('Поле обязательное')),
      coverage: z.string(),
      pledge: z.array(
        z.object({
          name: z.string().min(1, t('Поле обязательное')),
          external_appraiser_amount: z.number().optional(),
          available_amount_from_bank: z.number().min(1, t('Поле обязательное')),
          // z.number is necessary for percent data type conversion on sumbit
          percent: z.union([
            z.string().min(1, t('Поле обязательное')),
            z.number(),
          ]),
        }),
      ),
    })
    .superRefine((data, ctx) => {
      if (data.coverage !== 'insurance') {
        data.pledge.forEach((pledgeItem, index) => {
          // required AND at least 1
          if (
            pledgeItem.external_appraiser_amount === undefined ||
            pledgeItem.external_appraiser_amount < 1
          ) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t('Поле обязательное'),
              path: ['pledge', index, 'external_appraiser_amount'],
            });
          }
        });
      }
    });
};

export type UnderwriterConclusionSchemaType = z.infer<
  ReturnType<typeof createUnderwriterConclusionSchema>
>;
export type UnderwriterPledgeItem =
  UnderwriterConclusionSchemaType['pledge'][number];
export type UnderwriterPledgeItemKeys = keyof UnderwriterPledgeItem;
